export const fetchFormsData = async () => {
  try {
      const headers = new Headers({
          "cache-control": "max-age=172800"
      })
    const response = await fetch('./content/manage/app/forms.json', {
        headers: headers
    });
    const formsData = await response.json();
    return formsData;
  } catch (e) {
    console.log(e)
  }
};



// WEBPACK FOOTER //
// ./src/api/fetchFormsData.js